module.exports = ".label{\r\n    color: black !important;\r\n}\r\n\r\n.letraMaiscula{\r\n    text-transform: uppercase !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/modal-sessao/modal-sessao.component.css
// module id = ./src/app/shared/layout/modal-sessao/modal-sessao.component.css
// module chunks = main